import { render, staticRenderFns } from "./FormEditDetailChairSale.vue?vue&type=template&id=1131058b"
import script from "./FormEditDetailChairSale.vue?vue&type=script&lang=js"
export * from "./FormEditDetailChairSale.vue?vue&type=script&lang=js"
import style0 from "./FormEditDetailChairSale.vue?vue&type=style&index=0&id=1131058b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports